export const FLASH_1 = "flashNews1";
export const FLASH_2 = "flashNews2";
export const NEWS_1 = "newsletter1Url";
export const NEWS_2 = "newsletter2Url";
export const FLASH_1_EXPIRY = "flashNews1Expiry";
export const FLASH_2_EXPIRY = "flashNews2Expiry";
